import React, { useState } from 'react';
import { Reveal } from '../ui/Reveal';
import SafeIcon from '../common/SafeIcon';
import { motion, AnimatePresence } from 'framer-motion';

const faqs = [
  { q: "How long does a commercial appraisal typically take?", a: "Typically ranges from 2 to 4 weeks from the date of engagement and receipt of necessary documents." },
  { q: "What areas do you serve?", a: "We primarily serve Washington DC, Virginia, and Maryland, and throughout the East Coast for portfolio valuations." },
  { q: "Are your reports accepted by major lenders?", a: "Yes. Our MAI-designated appraisers adhere strictly to USPAP standards, widely accepted by banks and lending institutions." }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-24 bg-charcoal-900 border-t border-white/5">
      <div className="container mx-auto px-6 md:px-12 max-w-3xl">
        <Reveal>
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">Common Questions</h2>
          </div>
        </Reveal>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <Reveal key={index} delay={index * 0.1}>
              <div className="bg-charcoal-850 border border-white/10">
                <button
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                  className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none"
                >
                  <span className="font-semibold text-gray-200 pr-8">{faq.q}</span>
                  <SafeIcon 
                    name="Plus" 
                    className={`text-gold-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-45' : ''}`} 
                  />
                </button>
                
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div className="px-6 pb-5 text-gray-400 border-t border-white/5 pt-4 text-sm">
                        {faq.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;